import tableRelatedDeviceTypes from './tableRelatedDeviceTypes';
export default {
  title: 'Type',
  attributeName: 'device-types',
  getURL: 'device-types',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  sessionParams: [],
  tableConfig: tableRelatedDeviceTypes
};
